import {gql} from '@apollo/client'

export const UPLOAD_INVENTORY = gql`
  mutation UploadeInventory($baseUrl: String!, $fileMimeType: String!, $fileName: String!) {
    uploadeInventory(baseUrl: $baseUrl, fileMimeType: $fileMimeType, fileName: $fileName)
  }
  `

export const UPLOAD_VENDOR = gql`
  mutation UploadeVendor($baseUrl: String!, $fileMimeType: String!, $fileName: String!) {
    uploadeVendor(baseUrl: $baseUrl, fileMimeType: $fileMimeType, fileName: $fileName)
  }
`
export const IMPORT_SCAN_PATIENTS = gql`
  mutation importScanCenterPatients($fileDataString: String!, $fileMimeType: String!, $fileName: String!) {
    importScanCenterPatients(fileDataString: $fileDataString, fileMimeType: $fileMimeType, fileName: $fileName)
  }
`
export const IMPORT_PHARMACY_PATIENTS = gql`
  mutation importPharmacyPatients($fileDataString: String!, $fileMimeType: String!, $fileName: String!) {
    importPharmacyPatients(fileDataString: $fileDataString, fileMimeType: $fileMimeType, fileName: $fileName)
  }
`

export const ADD_NEW_VENDOR = gql`
  mutation createVendorProfile($vendorInput: vendorProfileInput!) {
    createVendorProfile(vendorInput: $vendorInput) {
      id
      mobileNumber
      name
      firmName
      email
      registrationNo
      gstNumber
      dlNumber
      phoneNumber
      pan
      address
      city
      state
      country
      district
      zip
      flNumber
      isActive
    }
  }
`

export const ADD_NEW_INVENTORY = gql`
  mutation addProductToinventory($productDetails: purchaseOrderDetails!) {
    addProductToinventory(productDetails: $productDetails)
  }
`
export const EDIT_APPOINTMENT_TIME = gql`
  mutation editAppointmentTime($userRoleId: ID, $appDurInput: appDurInput!) {
    editAppointmentTime(appDurInput: $appDurInput, userRoleId: $userRoleId)
  }
`

export const ADD_DOCTOR_TO_BUSINESS = gql`
  mutation addDoctorToBusiness(
    $businessdoctorInput: businessPharmadoctorInput!
  ) {
    addDoctorToBusiness(businessdoctorInput: $businessdoctorInput)
  }
`;

export const ADD_PATIENT_TO_PHARMACY = gql`
  mutation addPatientToPharmacy($patientInput: pPatientInput!) {
    addPatientToPharmacy(patientInput: $patientInput)
  }
`;

export const CREATE_SALES_ORDER = gql`
  mutation createSaleOrder(
    $orderInput: saleOrderInput!
    $orderDetails: [saleOrderDetails!]!
  ) {
    createSaleOrder(orderInput: $orderInput, orderDetails: $orderDetails)
  }
`;

export const CREATE_SALES_ORDER_DOCTOR = gql`
  mutation createSaleOrderForDoctor(
    $orderRequestId: ID!
    $orderInput: saleOrderInput!
    $orderDetails: [saleOrderDetails!]!
  ) {
    createSaleOrderForDoctor(
      orderRequestId: $orderRequestId
      orderInput: $orderInput
      orderDetails: $orderDetails
    )
  }
`;

export const CREATE_PURCHASE_ORDER = gql`
  mutation createPurchaseOrder(
    $orderInput: purchaseOrderInput!
    $orderDetails: [purchaseOrderDetails!]!
  ) {
    createPurchaseOrder(orderInput: $orderInput, orderDetails: $orderDetails) {
      invoiceNo
      invoiceDate
      netAmount
      id
    }
  }
`;

export const UPLOAD_OCR_FILE = gql`
  mutation uploadOcrFileV1($apimId: String, $baseUrl:String ) {
    uploadOcrFileV1(apimId: $apimId, baseUrl: $baseUrl)
  }
`;

export const GEMINI_OCR_AI = gql`
mutation extractGeminiPharmaInvoice($baseUrl:String!) {
 extractGeminiPharmaInvoice(baseUrl:$baseUrl)
}
`;

export const RETURN_SALE_ORDER = gql`
  mutation returnSaleOrder(
    $orderInput: returnSaleInput!
    $orderDetails: [returnOrd!]!
  ) {
    returnSaleOrder(
      orderInput: $orderInput
      orderDetails: $orderDetails
    )
  }
`;

export const RETURN_PURCHASE_ORDER = gql`
  mutation returnPurchaseOrder(
    $orderInput: returnOrderInput!
    $orderDetails: [returnOrd!]!
  ) {
    returnPurchaseOrder(orderInput: $orderInput, orderDetails: $orderDetails) {
      invoiceNo
      returnDate
      netAmount
    }
  }
`;

export const EDIT_UNIVERSAL_DISCOUNT = gql`
  mutation editUniversalDiscount($discountInput: discountInputs!) {
    editUniversalDiscount(discountInput: $discountInput)
  }
`;

export const CREATE_DISCOUNT_GROUP = gql`
  mutation createDiscountGroup($discountInput: discountInput!) {
    createDiscountGroup(discountInput: $discountInput)
  }
`;

export const EDIT_DISCOUNT_GROUP = gql`
  mutation editDiscountGroup($discountInput: discountInput!) {
    editDiscountGroup(discountInput: $discountInput)
  }
`;
export const DELETE_GROUP_DISCOUNT = gql`
  mutation deleteDiscountGroup($discountGroupName: String!) {
    deleteDiscountGroup(discountGroupName: $discountGroupName)
  }
`;

export const SET_INDIVIDUAL_DISCOUNT = gql`
  mutation setIndividualDiscount(
    $productId: ID!
    $discount: Float
    $isConfirm: Boolean
  ) {
    setIndividualDiscount(
      productId: $productId
      discount: $discount
      isConfirm: $isConfirm
    )
  }
`;

export const DELETE_INDIVIDUAL_DISCOUNT = gql`
  mutation deleteIndividualDiscount($productId: ID!) {
    deleteIndividualDiscount(productId: $productId)
  }
`;

export const EDIT_BUSINESS_STAFF = gql`
  mutation editBusinessStaff($userRoleId: ID!, $staffInput: editStaffInput!) {
    editBusinessStaff(userRoleId: $userRoleId, staffInput: $staffInput)
  }
`;

export const ACTIVATE_DEACTIVATE_STAFF = gql`
  mutation activateDeactivateStaff($userRoleId: ID!) {
    activateDeactivateStaff(userRoleId: $userRoleId)
  }
`;


export const ADD_BUSINESS_STAFF = gql`
  mutation addBusinessStaff($staffInput: staffInput!, $screenName: String!) {
    addBusinessStaff(staffInput: $staffInput, screenName: $screenName)
  }
`;

export const EDIT_BILLING_TEMPLATE = gql`
  mutation editSaleTemplateDesign($id: ID!, $templateInput: templateInput!) {
    editSaleTemplateDesign(id: $id, templateInput: $templateInput)
  }
`;

export const UPDATE_PHARMACY_TEMPLATE = gql`
  mutation updatePharmacyTemplate($templateTypeInput: templateTypeInput!) {
    updatePharmacyTemplate(templateTypeInput: $templateTypeInput)
  }
`;